export const sectionSortMethod_Static = 'static';
export const sectionSortMethod_Alphabet = 'alphabet';
export const sectionSortMethod_Timestamp = 'timestamp';
export const sectionSortMethods = [sectionSortMethod_Static, sectionSortMethod_Alphabet, sectionSortMethod_Timestamp];
//# sourceMappingURL=types.js.map